/* @flow */

import React, { Component, useEffect, createRef } from 'react';
import PropTypes from 'prop-types';
// $FlowIgnore
import { connect, useSelector } from 'react-redux';
// $FlowIgnore
import _ from 'lodash';
// $FlowIgnore
import { CSSTransition } from 'react-transition-group';

import Column from 'components/UIKit/Flex/Column';

// Don't remove this! Find out why we need it and tell us.
import SideNav from 'components/SideNav';
import Snackbar from 'components/UIKit/Snackbar';
import ScrollToContent from 'components/UIKit/ScrollToContent';
import { GlobalTooltip } from 'components/UIKit/Tooltip';
import Modal from 'components/UIKit/Modal';
import Banner from 'components/UIKit/Banner';

import { setMessage, resetMessage } from 'ducks/message';
import { forceLogout } from 'ducks/auth';
import { dismissNotification } from 'ducks/notifications';
import withRouting from './utils/withRouting';
import { Outlet, useLocation, useNavigate } from 'react-router';

class App extends Component {
  static propTypes = {
    children: PropTypes.node,
    dispatch: PropTypes.func.isRequired,
    router: PropTypes.object,
    history: PropTypes.object,
    message: PropTypes.object
  };

  // $FlowIgnore
  state = {
    contentNode: {}
  };

  transitionRef = createRef(null);

  componentDidMount() {
    this.setState({ contentNode: this.contentNode });
    if (localStorage.getItem('deleteTransactionSuccess')) {
      this.props.dispatch(setMessage('Delete Transaction Successful'));
      localStorage.removeItem('deleteTransactionSuccess');
    }
  }

  hideSnackbar() {
    let { dispatch } = this.props;
    dispatch(resetMessage());
  }

  contentNode: Object;

  render(): React.Element {
    let { message, modal, notifications, dispatch } = this.props;
    let { Component: ModalComponent } = modal;
    const modalStyle = modal.style;

    return (
      <Column style={{ flex: 1, overflow: 'hidden' }}>
        <ScrollToContent node={this.state.contentNode} />
        <Column>
          {notifications.map(n => (
            <Banner
              {...n}
              key={n.id}
              handleOnDismiss={() => dispatch(dismissNotification(n.id))}
            />
          ))}
        </Column>
        <Column
          ref={ref => (this.contentNode = ref)}
          tabIndex="0"
          style={{ flex: 1 }}
        >
          {this.props.children}
        </Column>
        <CSSTransition
          timeout={300}
          in={message !== null}
          nodeRef={this.transitionRef}
          classNames={"snackbar"}
          unmountOnExit
        >
          <div ref={this.transitionRef}>
            <Snackbar
              message={message?.message}
              dismissAction={this.hideSnackbar.bind(this)}
            />
         </div>
        </CSSTransition>
        <GlobalTooltip />
        <Modal isOpen={!!ModalComponent} style={modalStyle}>
          {ModalComponent ? <ModalComponent /> : null}
        </Modal>
        <Outlet />
      </Column>
    );
  }
}

const AppWithLoginRedirect = (props) => {
  const auth = useSelector(state => state.auth);
  const { location } = props.router;
  const navigate = useNavigate();

  const { message, dispatch } = props;

  useEffect(() => {
    const notLoggedIn = !auth.firstLoad && !auth.isFetching && !auth.isAuthorized;
     if (notLoggedIn) {
      navigate(
        {
          pathname: "/login",
          search: `?next=${encodeURIComponent(`${location.basename}${location.pathname}${location.search}`)}`,
        },
        {
          state: {
            next: `${location.basename}${location.pathname}${location.search}` 
          },
          replace: true,
        }
        );
    }
  }, [auth.firstLoad, auth.isFetching, auth.isAuthorized]);

  useEffect(() => {
    if (message) {
      if (
        message.status === 403 ||
        message.status === 401
      ) {
        dispatch(forceLogout());
        navigate(
          {
            pathname: "/login",
            search: `?next=${encodeURIComponent(`${location.basename}${location.pathname}${location.search}`)}`,
          },
          {
            state: {
              next: `${location.basename}${location.pathname}${location.search}`,
              sessionExpired: true
            },
            replace: true,
          }
        );
      }
    }
  }, [message]);

  return <App {...props} />
}

export default connect(state => ({
  message: state.message,
  projectRoles: state?.auth?.user?.projects?.gdc_ids,
  modal: state.modal,
  notifications: state.notifications
}))(withRouting(AppWithLoginRedirect));
